import userIcon from "./user.svg";
import cartIcon from "./cart.svg";
import arrowLeftIcon from "./arrowLeft.svg";
import supportIcon from "./support.svg";
import trackIcon from "./track.svg";
import guaranteeIcon from "./guarantee.svg";
import mobileIcon from "./mibile.svg";
import whatsappIcon from "./whatsapp.svg";
import telegramIcon from "./telegram.png";
import instagramIcon from "./instagram.png";
import facebookIcon from "./facebook.png";
import orangeArrowLeftIcon from "./orangeArrowLeftIcon.svg";
import closeIcon from "./close.svg";
import editIcon from "./edit.svg";
import smallArrowLeftIcon from "./smallArrowLeft.svg";
import downloadIcon from "./download.svg";
import trashIcon from "./trash.svg";
import microscope from "./microscope.svg";
import twoArrow from "./twoArrow.svg";
import LoginImg from "./login.png";
import MarvelStamp from "./MarvelStamp.png";
import FactorFooter from "./FactorFooter.png";

export {
  userIcon,
  cartIcon,
  arrowLeftIcon,
  orangeArrowLeftIcon,
  trackIcon,
  supportIcon,
  guaranteeIcon,
  mobileIcon,
  whatsappIcon,
  telegramIcon,
  instagramIcon,
  facebookIcon,
  closeIcon,
  editIcon,
  smallArrowLeftIcon,
  downloadIcon,
  trashIcon,
  microscope,
  twoArrow,
  LoginImg,
  MarvelStamp,
  FactorFooter,
};
